// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"491":"2c8a6bee","890":"c8a2573e"}[chunkId] + ".chunk.css";
};